import * as ActionTypes from './ActionTypes';

export const InitialInput = {
  date: '',
  place: '',
  person: '',
  subject: '',
  reason: '',
  condition: '',
  data: '',
  unit: ''
};

export const Inputs = (
  state = {
    errMess: null,
    inputs: []
  },
  action
) => {
  switch (action.type) {
    case ActionTypes.INPUTS_UPDATING:
      return {
        ...state,
        updatingId: action.payload, // Track which specific input is being updated
        errMess: null
      };
    case ActionTypes.ADD_INPUTS:
      return {
        ...state,
        isLoading: false,
        updatingId: null,
        errMess: null,
        inputs: action.payload
      };

    case ActionTypes.INPUTS_LOADING:
      return {
        ...state,
        isLoading: state.inputs.length === 0,
        updatingId: null,
        errMess: null
        // inputs: [],  // 2023.11.18
      };

    case ActionTypes.INPUTS_FAILED:
      return {
        ...state,
        isLoading: false,
        updatingId: null,
        errMess: state.inputs.length === 0 ? action.payload : null
      };

    case ActionTypes.ADD_INPUT:
      var input = action.payload;
      return {
        ...state,
        isLoading: false,
        updatingId: null,
        inputs: state.inputs.concat(input)
      };

    case ActionTypes.EDITED_INPUT:
      // ✅ FIXED: Create a NEW array with the updated item
      return {
        ...state,
        isLoading: false,
        updatingId: null,
        errMess: null,
        inputs: state.inputs.map(input =>
          input._id === action.payload._id ? action.payload : input
        )
      };

    default:
      return state;
  }
};
